import type { ObjectActionManifest } from "../types";
import { AUTOMATION } from "./automation";
import { CANVAS } from "./canvas";
import {
  CANVAS_EDGE,
  CANVAS_NODE_CHAT_SESSION,
  CANVAS_NODE_CONNECTOR,
  CANVAS_NODE_GENERIC,
  CANVAS_NODE_SECTION,
} from "./canvasNode";
import {
  CANVAS_NODE_ENTITY,
  CANVAS_NODE_ENTITY_FILE_RECORD,
} from "./canvasNodeEntity";
import { CHAT } from "./chat";
import { CONNECTOR } from "./connector";
import { FILE_RECORD, FILE_RECORD_FOLDER } from "./fileRecord";
import { MULTI_SELECTION } from "./multiSelection";
import { SKILL } from "./skill";
import { SKILL_TEMPLATE } from "./skillTemplate";
import { WORKSPACE_PRIVATE, WORKSPACE_TEAM } from "./workspace";

export {
  FILE_RECORD_DETAIL_SURFACES,
  FILE_RECORD_MENU_SURFACES,
  FILE_RECORD_TOOLBAR_SURFACES,
} from "./surfaces";

export const OBJECT_ACTION_MANIFEST: ObjectActionManifest = {
  workspace: WORKSPACE_TEAM,
  "workspace:private": WORKSPACE_PRIVATE,
  canvas: CANVAS,
  chat: CHAT,
  "file-record": FILE_RECORD,
  "file-record:folder": FILE_RECORD_FOLDER,
  connector: CONNECTOR,
  skill: SKILL,
  "skill-template": SKILL_TEMPLATE,
  automation: AUTOMATION,
  "canvas-node:entity": CANVAS_NODE_ENTITY,
  "canvas-node:entity:file-record": CANVAS_NODE_ENTITY_FILE_RECORD,
  "canvas-node:text-note": CANVAS_NODE_GENERIC,
  "canvas-node:canvas-text": CANVAS_NODE_GENERIC,
  "canvas-node:canvas-shape": CANVAS_NODE_GENERIC,
  "canvas-node:section": CANVAS_NODE_SECTION,
  "canvas-node:widget-node": CANVAS_NODE_GENERIC,
  "canvas-node:chat-session": CANVAS_NODE_CHAT_SESSION,
  "canvas-node:canvas-connector": CANVAS_NODE_CONNECTOR,
  // Ink has the same action surface as a connector: copy, stack, delete.
  "canvas-node:canvas-drawing": CANVAS_NODE_CONNECTOR,
  "canvas-edge": CANVAS_EDGE,
  "multi-selection": MULTI_SELECTION,
};
